import { render, staticRenderFns } from "./CurrencyOverrideForm.vue?vue&type=template&id=ed0a90a2"
import script from "./CurrencyOverrideForm.vue?vue&type=script&lang=js"
export * from "./CurrencyOverrideForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports